import { useQuery } from 'react-query';
import Container from '@/components/global/Container';
import { TitleAndDescription } from '@/components/shared/TitleAndDescription';
import { IComponentBlocksCustomerRadarFeedbackBlock, ICustomerRadarFeedback, ICustomerRadarFeedbackEntity } from '@/graphql/__generated__/global/types';
import { I18nLocales } from '@/interfaces/locales.interfaces';
import { fetchGlobalData } from '@/lib/strapiQueries';
import { useRouter } from 'next/router';
import { EmblaCarousel } from '../../elements/Carousel/Carousel';
import { CustomerRadarCard } from './CustomerRadarCard';

export const CustomerRadarBlock = ({ titleDescription }: IComponentBlocksCustomerRadarFeedbackBlock) => {
    const router = useRouter();
    const { data: global } = useQuery(`global-${router.locale}`, () => fetchGlobalData(router.locale as I18nLocales), { staleTime: Infinity });

    const testimonials = global?.customerRadarFeedbacks;
    // only show if there are more than 1 testimonial
    if (!testimonials || testimonials.data.length <= 1) {
        return;
    }

    return (
        <>
            {titleDescription && (
                <Container>
                    <TitleAndDescription {...titleDescription} />
                </Container>
            )}
            <Container paddingX={false} maxWidth="xl">
                <EmblaCarousel
                    emblaOptions={{
                        align: 'start',
                        slidesToScroll: 'auto',
                        containScroll: 'trimSnaps',
                        loop: testimonials?.data.length > 3 ? true : false,
                    }}
                >
                    {({ emblaRef, scrollSnaps, scrollTo, scrollProgress, scrollNext, scrollPrev }) => {
                        return (
                            <>
                                <EmblaCarousel.Slides ref={emblaRef}>
                                    {testimonials?.data?.map((card: ICustomerRadarFeedbackEntity, index: number) => {
                                        return <CustomerRadarCard key={index} {...(card?.attributes as ICustomerRadarFeedback)} stockPhotoIndex={index as number} />;
                                    })}
                                </EmblaCarousel.Slides>
                                <Container maxWidth="xl">
                                    <EmblaCarousel.ProgressBar
                                        max={scrollSnaps.length}
                                        scrollTo={scrollTo}
                                        centered={true}
                                        scrollProgress={scrollProgress}
                                        scrollNext={scrollNext}
                                        scrollPrev={scrollPrev}
                                    />
                                </Container>
                            </>
                        );
                    }}
                </EmblaCarousel>
            </Container>
        </>
    );
};

export default CustomerRadarBlock;
